import React from "react";
import './loaderStyles.css';
export default function LoaderCss() {
  return (
    <div className="absolute top-[48%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20">
      <div className="loader"></div>
    </div>
  );
}
